module.exports = __webpack_public_path__ + "fonts/ralewaylightitalic.754199b.woff";